import React from 'react';
import PermissionDenied from './PermissionDenied';

const PERMISSION_KEYWORDS = ['permission', 'forbidden', 'unauthorized', 'access denied', 'FORBIDDEN'];

function isPermissionError(error: Error): boolean {
    const message = error?.message?.toLowerCase() ?? '';
    return PERMISSION_KEYWORDS.some(keyword => message.includes(keyword.toLowerCase()));
}

interface PermissionErrorBoundaryState {
    hasPermissionError: boolean;
    otherError: Error | null;
}

class PermissionErrorBoundary extends React.Component<React.PropsWithChildren<{}>, PermissionErrorBoundaryState> {
    state: PermissionErrorBoundaryState = {
        hasPermissionError: false,
        otherError: null,
    };

    static getDerivedStateFromError(error: Error): PermissionErrorBoundaryState {
        if (isPermissionError(error)) {
            return { hasPermissionError: true, otherError: null };
        }
        return { hasPermissionError: false, otherError: error };
    }

    render() {
        if (this.state.hasPermissionError) {
            return <PermissionDenied />;
        }

        if (this.state.otherError) {
            throw this.state.otherError;
        }

        return this.props.children;
    }
}

export default PermissionErrorBoundary;
